export const ACTION_NAV_COOKIE_PREFIX = "action_nav_";
export const AUTH_COOKIE_PREFIX = "sb-";
export const AUTH_ERROR_COOKIE_NAME = "auth_error";
export const GUEST_ID_COOKIE_NAME = "pollia_guest_id";
export const GUEST_ID_COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 90;
